export default "__VITE_ASSET__CTg6Xzja__"